import { useState } from 'react'
import PhoneInput from '@components/ui/PhoneInput'
import styles from './ApplyForm.module.css'

const industries = [
  { icon: '🏢', name: 'Corporate Offices' },
  { icon: '🏬', name: 'Commercial Buildings' },
  { icon: '💻', name: 'IT Parks' },
  { icon: '🛍️', name: 'Retail & Showrooms' },
  { icon: '🏥', name: 'Healthcare & Institutional Spaces' },
]

const ApplyForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    companyName: '',
    city: '',
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h2 className={styles.heading}>
            Complete HVAC Solutions for Commercial & Corporate Spaces
          </h2>
          <p className={styles.text}>
            We specialize in HVAC system design, sales, installation, and
            maintenance—delivering efficient, reliable, and future-ready comfort
            solutions.
          </p>
          <div className={styles.industriesSection}>
            <h3 className={styles.industriesTitle}>Industries We Serve</h3>
            <div className={styles.industriesList}>
              {industries.map((industry) => (
                <div key={industry.name} className={styles.industryItem}>
                  <span className={styles.industryIcon}>{industry.icon}</span>
                  <span className={styles.industryName}>{industry.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <h3 className={styles.formTitle}>Get in Touch</h3>
            <div className={styles.field}>
              <label className={styles.label}>Full Name *</label>
              <input
                type="text"
                name="fullName"
                className={styles.input}
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Contact Number *</label>
              <PhoneInput
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Contact Email *</label>
              <input
                type="email"
                name="email"
                className={styles.input}
                placeholder="contact@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Company Name</label>
              <input
                type="text"
                name="companyName"
                className={styles.input}
                placeholder="Enter your company name"
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>City / Location *</label>
              <input
                type="text"
                name="city"
                className={styles.input}
                placeholder="Enter your city or location"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className={styles.submit}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default ApplyForm
